export default __webpack_public_path__ + "0b455b3007bda3df31da69f98463193f.png";